import axios from 'axios'

// state
const state = {
  btn3D: true,
  kpisGeneric: null,
  alertsWeek: null,
  alertsToday: null,
  activeCampaigns: null,
  inactiveCampaigns: null,
  campaignDetail: null,
  campaignLevelState: null,
  campaignLevelProcedure: null,
  stationByIdChart: null,
  executeModel: null,
  basemap: [{'label': 'Positron', 'name': 'Positron', 'owner': 'CartoDB', 'provider': 'XYZ', 'requestKey': false, 'key': '', 'url': 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', 'layers': [], 'isLabeling': false, 'license': 'https://www.openstreetmap.org/copyright', 'default': true, 'labeling': false}, {'label': 'OpenStreetMaps', 'name': 'MapnikLabels', 'owner': 'OpenStreetMaps Foundation', 'provider': 'OSM', 'requestKey': false, 'key': '', 'url': 'https://a.tile.openstreetmap.org/', 'layers': [], 'isLabeling': false, 'license': 'https://www.openstreetmap.org/copyright', 'default': false, 'labeling': false}, { 'label': 'Ortoimagen', 'name': 'ortoimagen_lpa', 'owner': 'Ayuntamiento de Las Palmas de Gran Canaria', 'provider': 'WMS', 'requestKey': false, 'key': '', 'url': 'https://idecan1.grafcan.es/ServicioWMS/OrtoExpress', 'layers': [ 'ortoexpress' ], 'isLabeling': false, 'license': 'Ayuntamiento de Las Palmas de Gran Canaria', 'default': false, 'labeling': false }],
  selectBasemap: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
  profile: null,
  poisGraphData: null,
  currentKpiData: null,
  selectValue3D: ['isCesium3DTileset']
}

// Getters
const getters = {
  getSelectValue3D (state) {
    return state.selectValue3D
  },
  getbtn3D (state) {
    return state.btn3D
  },
  getKpisGeneric (state) {
    return state.kpisGeneric
  },
  getAlertsTodayData (state) {
    return state.alertsToday
  },
  getAlertsWeekData (state) {
    return state.alertsWeek
  },
  getActiveCampaignsData (state) {
    return state.activeCampaigns
  },
  getInactiveCampaignsData (state) {
    return state.inactiveCampaigns
  },
  getStationByIdChartData (state) {
    return state.stationByIdChart
  },
  getExecuteModel (state) {
    return state.executeModel
  },
  getBasemap (state) {
    return state.basemap
  },
  getSelectBasemap (state) {
    return state.selectBasemap
  },
  getProfile (state) {
    return state.profile
  },
  getPoisGraphData (state) {
    return state.poisGraphData
  },
  getCurrentKpiData (state) {
    return state.currentKpiData
  }
}
// Actions
const actions = {
  updateProfile ({ commit, state }, data) {
    commit('UPDATE_PROFILE', data)
  },
  updateSelectBasemap ({ commit, state }, data) {
    commit('UPDATE_SELECTBASEMAP', data)
  },
  updateSelect3D ({ commit, state }, data) {
    commit('UPDATE_SELECT3D', data)
  },
  updateCallService ({ commit, state }, data) {
    axios({
      method: data.method,
      url: data.url,
      headers: data.headers
    }).then((response) => {
      commit(data.mutation, response.data)
    }).catch((error) => {
      console.error(error)
    })
  },
  /*
  updateBasemap (data) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'GET',
        url: process.env.SERVICES_PROVIDER + '/api/dashboard/getBaseMaps',
        headers: {
          Accept: 'application/json',
          Authorization: `${sessionStorage.getItem('sessionToken')}`
        },
      }).then((response) => {
        commit('UPDATE_BASEMAP', response.data)
        resolve({ value: response.data })
      }).catch((error) => {
        console.error(error)
        resolve({ value: false })
      })
    })
  }
  */
  updateKpisGeneric ({ commit, state }, data) {
    const store = this
    let dataService = {
      method: 'GET',
      endpoint: '/api/kpis/' + data.product + '/' + data.time,
      data: null,
      params: {
        // product: data.product,
        typeProduct: data.typeProduct,
        type: data.type,
        interval: data.interval,
        intervalUnit: data.intervalUnit,
        city: 'ES LPA'
      },
      mutation: 'UPDATE_KPIS_GENERIC'
    }
    store.dispatch('callService', dataService)
  },
  updateAlertsCampaigns ({ commit, state }, data) {
    const store = this
    let muta = null
    if (data.subtype === 'today') {
      muta = 'UPDATE_ALERTS_TODAY'
    } else if (data.subtype === 'lastSevenDays') {
      muta = 'UPDATE_ALERTS_WEEK'
    } else if (data.subtype === 'activo') {
      muta = 'UPDATE_ACTIVE_CAMPAIGNS'
    } else if (data.subtype === 'inactivo') {
      muta = 'UPDATE_INACTIVE_CAMPAIGNS'
    } else {
      console.log('El tipo recibido no es correcto')
    }
    if (muta !== null) {
      let dataService = {
        method: 'GET',
        data: null,
        params: {
          country: 'ES',
          region: 'ES-GC',
          city: 'ES LPA'
        },
        mutation: muta
      }
      if (data.type === 'alert') {
        dataService.endpoint = '/api/dashboard/alerts/' + data.subtype
      } else if (data.type === 'campaign') {
        dataService.endpoint = '/api/dashboard/campanias'
        dataService.params.numberItems = data.numberItems
        dataService.params.page = data.page
        dataService.params.state = data.subtype
      }
      store.dispatch('callService', dataService)
    }
  },
  updateLevelStateCampaign ({ commit, state }, data) {
    const store = this
    state.campaignLevelState = null
    let dataService = {
      method: 'POST',
      endpoint: '/api/dashboard/campanias/' + data.id + '/state/' + data.state + '/level/' + data.level,
      data: null,
      params: {
        id: data.id,
        level: data.level,
        state: data.state
      },
      mutation: 'UPDATE_LEVEL_STATE_CAMPAIGN'
    }
    store.dispatch('callService', dataService)
  },
  updateLevelProcedureCampaign ({ commit, state, msg }, data) {
    const store = this
    state.campaignLevelState = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/dashboard/campanias/' + data.id + '/level/' + data.level,
      data: null,
      params: {
        id: data.id,
        level: data.level
      },
      msg: {
        ok: 'ok',
        error: 'errorrr'
      },
      mutation: 'UPDATE_LEVEL_PROCEDURE_CAMPAIGN'
    }
    store.dispatch('callServiceMsg', dataService)
  },
  // Update indicators data Station by Id meteo chart
  updateStationByIdChartData ({ commit, state }, data) {
    const store = this
    state.kpisInterval = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/dashboard/indicators/stations/' + data.stationId + '/charts/' + data.chartType + '/chartData',
      data: null,
      params: {
        chartType: data.chartType,
        timeInterval: data.timeInterval,
        stationId: data.stationId,
        country: 'ES',
        region: 'ES-GC',
        city: 'ES LPA'
      },
      mutation: 'UPDATE_STATIONBYID_CHART_DATA'
    }
    store.dispatch('callService', dataService)
  },
  updateExecuteModel ({ commit, state }, data) {
    const store = this
    let dataService = {
      method: 'POST',
      endpoint: '/api/models/executeModel',
      data: null,
      params: {
        params: data.params,
        modelName: data.modelName
      },
      mutation: 'UPDATE_EXECUTE_MODEL'
    }
    store.dispatch('callService', dataService)
  },
  updatePoisGraphData ({ commit, state }, data) {
    const store = this
    let dataService = {
      method: 'GET',
      endpoint: '/api/dashboard/kpi/districtPoisGraphs',
      data: null,
      params: {
        country: 'ES',
        region: 'ES-GC',
        city: 'ES LPA'
      },
      mutation: 'UPDATE_POIS_GRAPH_DATA'
    }
    store.dispatch('callService', dataService)
  },
  async updateCurrentKpis ({ commit, state }, data) {
    const store = this
    let dataService = {
      method: 'GET',
      endpoint: `/api/kpis/${data.product}/current`,
      data: null,
      params: {
        type: data.type,
        city: data.city
      },
      mutation: 'UPDATE_CURRENT_KPIS'
    }
    return store.dispatch('callService', dataService)
  }
}
// mutations
const mutations = {
  UPDATE_EXECUTE_MODEL (state, data) {
    state.executeModel = data
  },
  UPDATEBTN3D (state, data) {
    state.btn3D = !state.btn3D
  },
  UPDATE_KPIS_GENERIC (state, data) {
    state.kpisGeneric = data
  },
  UPDATE_ALERTS_WEEK (state, data) {
    state.alertsWeek = data
  },
  UPDATE_ALERTS_TODAY (state, data) {
    state.alertsToday = data
  },
  UPDATE_ACTIVE_CAMPAIGNS (state, data) {
    state.activeCampaigns = data
  },
  UPDATE_INACTIVE_CAMPAIGNS (state, data) {
    state.inactiveCampaigns = data
  },
  UPDATE_CAMPAIGN (state, data) {
    state.campaignDetail = data
  },
  UPDATE_LEVEL_STATE_CAMPAIGN (state, data) {
    state.campaignLevelState = data
  },
  UPDATE_LEVEL_PROCEDURE_CAMPAIGN (state, data) {
    state.campaignLevelProcedure = data
  },
  UPDATE_STATIONBYID_CHART_DATA (state, data) {
    state.stationByIdChart = data
  },
  UPDATE_BASEMAP (state, data) {
    state.basemap = data
  },
  UPDATE_SELECTBASEMAP (state, data) {
    state.selectBasemap = data
  },
  UPDATE_PROFILE (state, data) {
    state.profile = data
  },
  UPDATE_POIS_GRAPH_DATA (state, data) {
    state.poisGraphData = data
  },
  UPDATE_CURRENT_KPIS (state, data) {
    state.currentKpiData = data
  },
  UPDATE_SELECT3D (state, data) {
    state.selectValue3D = data
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/globales.js